import { useIntl } from "react-intl";

interface Props {
  rows: number;
  columns: number;
}

function BaseTableLoader({ rows, columns }: Props) {
  const intl = useIntl();

  const skeletonRows = Array.from({ length: rows }, (_, rowIndex) => {
    const skeletonCells = Array.from({ length: columns }, (_, colIndex) => (
      <div key={colIndex} className="skeleton-cell" />
    ));

    return (
      <div key={rowIndex} className="skeleton-row">
        {skeletonCells}
      </div>
    );
  });

  return (
    <div
      className="table-loader"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span id="skeleton-loading" className="visually-hidden">
        {intl.formatMessage({ id: "customComponents.loading" })}
      </span>
      {skeletonRows}
    </div>
  );
}

export default BaseTableLoader;
